import React from "react";
import { Container } from "react-bootstrap";
import TextMarker from "./textMarker";
import classes from './text.module.css';

const TmList = ({title, textmarkers}) => {
    return(
        <Container fluid="md">
            <h1>{title}</h1>
            <div className={classes.textCol}>
                {textmarkers.map((textmarker, index) => 
                    <TextMarker number={index +1} textmarker={textmarker} key={textmarker.id} />
                )}
            </div>
        </Container>
    )
}

export default TmList;